import { TranslateService } from '@ngx-translate/core';

export class Translatable {

    protected localLang: string;

    public constructor(private translateObject = {}, private translateService: TranslateService) {
        this.localLang = translateService.currentLang;
    }

    public toString() {
        return this.translateObject[this.translateService.currentLang] || '';
    }

    public toJSON() {
        return this.translateObject;
    }

    public translate() {
        return this.translateObject[this.translateService.currentLang] || '';
    }

    public getTranslation(lang: string) {
        return this.translateObject[lang] || '';
    }

    public get ngModel() {
        return this.translateObject[this.localLang];
    }

    public set ngModel(value: string) {
        this.translateObject[this.localLang] = value;
    }

    public setLocalLang(lang: string) {
        this.localLang = lang;
    }

    public getLocalLang() {
        return this.localLang;
    }
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/localization/translatable.ts